module.exports = __webpack_public_path__ + "images/huazhu2.jpg?v=59a4ab4c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/huazhu2.jpg
 ** module id = 107
 ** module chunks = 1 2
 **/